export default __webpack_public_path__ + "static/media/hacktoberFest.848887b8.jpeg";